export default "__VITE_ASSET__DVeUfJ$l__"